const func = $target => {
	window.loader.key('zxcvbn', function() {
		var strengthScore = 0,
			$input = $target.find('input'),
			$meter = $target.find('.progress-bar'),
			$text = $target.find('.meter-text');

		var strength = {
			0: 'Worst',
			1: 'Bad',
			2: 'Weak',
			3: 'Good',
			4: 'Strong'
		};
		var colours = {
			0: 'bg-danger',
			1: 'bg-danger',
			2: 'bg-warning',
			3: 'bg-success',
			4: 'bg-success'
		};

		$input.on('input', function(e) {
			var val = $input.val(),
				result = zxcvbn(val);

			strengthScore = result.score;
			//console.log(result);
			if (result.score < 1) {
				result.score = 0.2;
				strengthScore = 0;
			}
			if (result.password.length == 0) {
				result.score = 0;
			}
			//if (result.score > 2) {
			//$input.attr('pattern', '.{6,}');
			//} else {
			//$input.attr('pattern', '[.]');
			//}
			$meter.width(result.score * 25 + '%');
			$meter.removeClass('bg-danger bg-warning bg-success').addClass(colours[strengthScore]);

			if (val !== '') {
				//$text.text(strength[result.score]);
				$text.text(result.feedback.warning);
				//$suggestions.text(result.feedback.warning);
			} else {
				$text.text('');
				//$suggestions.text('');
			}
		});
	});
};

export default func;
